var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center","margin-right":"10px","width":"80px"}},[_c('v-chip',{attrs:{"color":_vm.getColorMonth()}},[_vm._v(" "+_vm._s(_vm.getTagMonth())+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }